<!-- 采购协议详情 -->
<template>
  <div class="content">
    <div class="title-h2">协议信息</div>
    <!-- 协议信息 -->
    <el-form label-width="140px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="协议编号：">{{ agreementDetail.agreementCode }}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="协议名称：">{{ agreementDetail.agreementName }}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="协议甲方企业：">{{ agreementDetail.firstParty }}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="供应商企业：">
            {{ agreementDetail.supplierCompanyName }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="协议有效时间：">
            <div class="ellipsis">
              {{ agreementDetail.startDate + '至' + agreementDetail.endDate }}
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- tabs -->
    <e-tabs
      :tabsValue="tabsActive"
      :tabPaneData="tabsList"
      @tabClick="handleTabs"
      style="margin: 20px 0"
    />
    <e-table-list
      :index-show="tabsActive == '0'"
      :table-data="tableData"
      :table-label="tableLabel"
      :maxHeight="'330'"
    ></e-table-list>

    <!-- 备注 -->
    <el-form style="margin-top: 20px" ref="form" label-width="100px">
      <el-form-item label="备注：">
        <el-input
          style="width: 70%"
          type="textarea"
          :disabled="true"
          :rows="2"
          v-model="agreementDetail.remark"
        ></el-input>
      </el-form-item>
      <el-form-item label="附件：">
        <!-- <div style="color:#0064C8; cursor: pointer;display: flex; align-items: center"  @click="handleDownload(item.attachmentPath)" >

        </div> -->
        <el-button
          type="text"
          v-for="(item, index) in agreementDetail.agreementAttachment"
          :key="index"
          @click="handleDownload(item.attachmentPath)"
        >
          {{ item.attachmentName }}
        </el-button>
      </el-form-item>
    </el-form>
    <!-- 协议商品信息 -->
    <div class="title-h2">协议商品信息</div>
    <e-table-list
      :index-show="true"
      :table-data="productTableData"
      :table-label="productTableLabel"
    >
      <template v-slot:image="slot">
        <img :src="slot.scope.row.defaultImage" style="width: 48px; height: 48px" />
      </template>
      <template v-slot:rate="slot">
        {{
          slot.scope.row.price
            ? slot.scope.row.agreementPrice
              ? formatRate(slot.scope.row)
              : ''
            : '-'
        }}
      </template>
    </e-table-list>
    <!-- 分页 -->
    <el-pagination
      style="margin-top: 20px"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :pager-count="5"
      :page-sizes="[10, 20, 30]"
      layout="total, sizes, prev, pager, next, jumper"
      :current-page="queryData.pageNum"
      :total="pageTotal"
      :page-size.sync="queryData.pageSize"
      prev-text="上一页"
      next-text="下一页"
    ></el-pagination>
    <div class="btn-other btn" @click="handleGoBack">< &nbsp;&nbsp;返回</div>
  </div>
</template>

<script>
import eTabs from '@/modules/projectA/components/common/e-tabs.vue';
import eTableList from '@/modules/projectA/components/common/e-table-list';
import Api from '@/modules/projectA/api/purchase';
export default {
  components: {
    eTabs,
    eTableList,
  },
  data() {
    return {
      agreementDetail: {},
      queryData: {
        pageNum: 1,
        pageSize: 10,
      },
      pageTotal: 0,
      formData: {
        remark: '',
      },
      productTableData: [],
      productTableLabel: [
        {
          label: '图片',
          param: 'defaultImage',
          align: 'center',
          slot: 'image',
        },
        { label: '商品名称', param: 'skuName', align: 'center' },
        { label: '商品编号', param: 'skuCode', align: 'center' },
        { label: '计量单位', param: 'unitValue', align: 'center' },
        { label: '协议价（元）', param: 'agreementPrice', align: 'center' },
        { label: '市场价（元）', param: 'price', align: 'center' },
        { label: '优惠比例', param: 'rate', align: 'center', slot: 'rate' },
        {
          label: '确认状态',
          param: 'status',
          align: 'center',
          render: row => {
            let obj = {
              0: '未提交',
              1: '待确认',
              2: '已确认',
              3: '拒绝',
            };
            return obj[Number(row.status)] || '已确认';
          },
        },
      ],
      tableData: [],
      tableData1: [],
      tableData2: [],
      tableLabel: [{ label: '企业名称', param: 'companyName', align: 'center' }],
      tableLabel2: [
        { label: '序号', param: 'id', align: 'center', width: '50' },
        { label: '物料类别', param: 'categoryName', align: 'center' },
        { label: '序号', param: 'id2', align: 'center', width: '50' },
        { label: '物料类别', param: 'name2', align: 'center' },
      ],
      tabsActive: '0',
      tabsList: [
        {
          label: '采购执行企业',
          id: '0',
        },
        {
          label: '采购协议物料类别',
          id: '1',
        },
      ],
    };
  },
  mounted() {
    let agreementId = this.$route.query.agreementId || '';
    this.queryAgreementInfoById(agreementId);
    this.queryAgreementCategoryById(agreementId);
    this.queryEpecPriceByPage();
  },
  methods: {
    async queryEpecPriceByPage() {
      let params = {
        agreementId: this.$route.query.agreementId,
        pageSize: this.queryData.pageSize,
        pageNum: this.queryData.pageNum,
        supplierCompanyId: this.agreementDetail.supplierCompanyId,
        materialCode: this.agreementOrigin ? this.materialCode : '',
      };
      let res = await Api.queryEpecPriceByPage(params);
      if (res.code == '200') {
        this.productTableData = res.data.records;
        this.pageTotal = res.data.total;
      }
    },
    // 协议商品信息
    async queryAgreementInfoById(agreementId) {
      let res = await Api.queryAgreementInfoById({ agreementId });
      if (res.code == '200') {
        this.agreementDetail = res.data;
        this.tableData1 = this.agreementDetail.agreementMembers;
        this.tableData = this.tableData1;
      }
    },
    // 查询物料列表
    async queryAgreementCategoryById(agreementId) {
      let res = await Api.queryAgreementCategoryById({ agreementId });
      if (res.code == '200') {
        let arr1 = [];
        let arr2 = [];
        res.data.forEach((item, index) => {
          item.id = index;
          if ((index + 1) % 2 == 0) {
            arr1.push(item);
          } else {
            arr2.push(item);
          }
        });
        arr2.forEach(item => {
          arr1.forEach(i => {
            if (i.id + 1 == item.id) {
              i.name2 = item.categoryName;
              i.id2 = item.id;
            }
          });
        });
        this.tableData2 = arr1;
      }
    },
    handleGoBack() {
      this.$router.back();
    },
    formatRate(val) {
      return (((val.price - val.agreementPrice) / val.price) * 100).toFixed(2) + '%';
    },
    handleTabs(row) {
      this.tabsActive = row.name;
      if (this.tabsActive == '0') {
        this.tableData = this.tableData1;
        this.tableLabel = this.$options.data().tableLabel;
      } else {
        this.tableData = this.tableData2;
        this.tableLabel = this.$options.data().tableLabel2;
      }
    },
    // 下载附件
    handleDownload(val) {
      window.open(val);
    },
    // 分页
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      this.queryEpecPriceByPage();
    },
    handleSizeChange(val) {
      this.queryData.pageNum = 1;
      this.queryData.pageSize = val;
      this.queryEpecPriceByPage();
    },
  },
};
</script>

<style lang="scss" scoped>
.title-h2 {
  font-size: 16px;
  margin: 10px 0;
}
::v-deep .el-form-item {
  margin-bottom: 10px;
}
.btn-other {
  border-color: #2587ff;
  color: #2587ff;
  border-radius: 0;
  margin-top: 20px;
}
</style>
